type TClasses =
  | 'circle-filled-result'
  | 'squared-filled'
  | 'squared-outlined-2'
  | 'squared-outlined'
  | 'circle-outlined'
  | 'circle-outlined-2'
  | 'circle-filled'
  | '';

type TGetClasses = (
  pars: string[],
  index: number,
  rawValue: string,
  markMiddle: boolean
) => TClasses;

export const getClasses: TGetClasses = (pars, index, rawValue, markMiddle) => {
  if (String(rawValue) === '' || pars.length === 0 || index < 0) {
    return '';
  }

  if (index === pars.length - 1 || (markMiddle && index === Math.floor(pars.length / 2 - 1))) {
    return `circle-filled-result`;
  }

  const value = Number(rawValue);
  const par = Number(pars[index]);

  return value > par + 2
    ? 'squared-filled'
    : value === par + 2
    ? 'squared-outlined-2'
    : value === par + 1
    ? 'squared-outlined'
    : value === par - 1
    ? 'circle-outlined'
    : value === par - 2
    ? 'circle-outlined-2'
    : value < par - 2
    ? 'circle-filled'
    : '';
};
